import { Button } from '@1trading/react/components/ui/button';
import { GradientIcon } from '@1trading/react/components/ui/gradient-icon';
import { FilePenLine } from 'lucide-react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { PageHeading, PageHeadingDescription, PageHeadingTitle } from '@/components/ui/page-heading';
import { InstitutionOnboardingProgressStep, useProgress } from '@/context/progress';
import { useDetailsNext } from '@/features/institution/hooks/useDetailsNext';
import { INSTITUTION_DETAILS_TYPE } from '@/features/institution/utils';
import BaseLayout from '@/layouts/base';
import LoadingPage from '@/pages/loading';

const InstitutionOnboardingUpdatePage = () => {
  const { isLoading, data: detailsNext } = useDetailsNext(INSTITUTION_DETAILS_TYPE.ONBOARDING);
  const { setCurrentStep } = useProgress();
  const { t } = useTranslation();

  useEffect(() => {
    return setCurrentStep(InstitutionOnboardingProgressStep.INSTITUTION_INFORMATION, 0);
  }, [setCurrentStep]);

  if (isLoading) return <LoadingPage />;

  return (
    <BaseLayout className="-md:justify-center space-y-8" size="sm">
      <GradientIcon className="size-32 mx-auto" strokeWidth={1.5}>
        <FilePenLine />
      </GradientIcon>
      <PageHeading centered>
        <PageHeadingTitle>{t('institutionDetails.update.title')}</PageHeadingTitle>
        <PageHeadingDescription>{t('institutionDetails.update.description')}</PageHeadingDescription>
      </PageHeading>
      {detailsNext ? (
        <footer className="flex flex-col gap-4">
          <Button size="lg" variant="primary" asChild>
            <Link to={detailsNext.route} replace>
              {t('buttons.continue')}
            </Link>
          </Button>
        </footer>
      ) : null}
    </BaseLayout>
  );
};
InstitutionOnboardingUpdatePage.displayName = 'InstitutionOnboardingUpdatePage';

export default InstitutionOnboardingUpdatePage;
